"use strict";

/**
 * @classdesc
 * Aktion zum Auflösen eines Gruppenlayers.
 *
 * @class
 * @extents gc.gis.action.GCAbstractAction
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.action.layer.DissolveGroup = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	this.func = this.doExecute;
	this.args = [options.group];
};
gc.gis.action.layer.DissolveGroup.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Führt die Aktion aus.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCGroupLayer} layer Aufzulösender Gruppenlayer.
 * @throws {TypeError} Wenn es sich nicht um einen Gruppenlayer handelt.
 */
gc.gis.action.layer.DissolveGroup.prototype.doExecute = function( layer )
{
	if( layer instanceof gc.gis.layer.GCGroupLayer )
	{
		layer.dissolve();
	}
	else
	{
		throw new TypeError('Only group layers can be dissolved');
	}
};

